import type { StaleRemoval } from "@noa/api-core";

/** Which message tells the admin what a sync's removal step did, under uploadAdmin.progress.removal. */
export type RemovalNotice = {
  kind: "removed" | "blocked" | "dryRun" | "skipped";
  type: "info" | "warning";
};

/** The notice for a sync's removal step of the documents its source no longer lists; null
 * when there is nothing to tell: no step, or nothing to remove. */
export function staleRemovalNotice(removal: StaleRemoval | null | undefined): RemovalNotice | null {
  if (!removal) return null;
  switch (removal.outcome) {
    case "removed":
      if (!removal.removed && !removal.images_left) return null;
      return { kind: "removed", type: removal.images_left ? "warning" : "info" };
    case "blocked":
      return { kind: "blocked", type: "warning" };
    case "dry_run":
      return { kind: "dryRun", type: "info" };
    case "skipped":
      return { kind: "skipped", type: "info" };
  }
}
